<mat-card-content class="mat-card-content">
  <div class="mat-card-info">
    <p>
      <!-- Keep this span for css (and future description if needed) -->
    </p>
    <div class="mat-card-buttons">
      <button
        matIconButton
        aria-label="Center map on data"
        matTooltip="Center map on data"
        (click)="centerMap()"
      >
        <mat-icon>gps_fixed</mat-icon>
      </button>
      <button
        matIconButton
        aria-label="Download CM layer"
        matTooltip="Download CM layer"
        (click)="downloadCMLayer()"
        [disabled]="isDownloading$()"
      >
        @if (isDownloading$()) {
          <mat-icon><mat-spinner diameter="24"></mat-spinner></mat-icon>
        } @else {
          <mat-icon>download</mat-icon>
        }
      </button>

      @if (isConnected$() && canBeSaveAsPL$()) {
        <!-- ! tooltip must be outside because button disabled hide tooltip -->
        @let spaceState = stillSpaceOnAccountState$();
        <span
          [matTooltip]="
            spaceState.status !== 'success'
              ? 'You cannot save as personal layer right now. Try again later.'
              : spaceState.data
                ? 'Save as personal layer'
                : 'Your account is already full. Delete data to add new layers.'
          "
        >
          <button
            matIconButton
            aria-label="Save as personal layer"
            matTooltip=""
            [disabled]="isSaving$()"
            [disabled]="spaceState.status !== 'success' || !spaceState.data"
            (click)="saveInPersonalLayer()"
          >
            @if (isSaving$()) {
              <mat-icon><mat-spinner diameter="24"></mat-spinner></mat-icon>
            } @else {
              <mat-icon>create_new_folder</mat-icon>
            }
          </button>
        </span>
      }
    </div>
  </div>

  <div class="mat-card-symbology">
    @if (layer.type == 'custom' && layer.symbology) {
      <app-custom-symbology [symbology]="layer.symbology"></app-custom-symbology>
    } @else if (layer.type) {
      <img src="{{ symbologyUrl }}{{ layer.type }}" onerror="this.style.visibility = 'hidden'" />
    } @else {
      <p>No legend defined</p>
    }
  </div>
</mat-card-content>
